import { render, staticRenderFns } from "./LocationSearchTerm.vue?vue&type=template&id=23465cbe&scoped=true"
import script from "./LocationSearchTerm.vue?vue&type=script&lang=js"
export * from "./LocationSearchTerm.vue?vue&type=script&lang=js"
import style0 from "./LocationSearchTerm.vue?vue&type=style&index=0&id=23465cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23465cbe",
  null
  
)

export default component.exports